import { FC } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import { useCountDown } from 'ahooks';
import { useProductStore } from '../../ProductProvider';
import { IPageStatus } from '../../config/IPageStatus';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { useLang } from '@/i18n';

const B: FC = () => {
    const { t } = useLang('ces2025');
    const { getSystemTime } = useGlobal();
    const { pageStatus, timeLine } = useProductStore();
    // 写死使用阶段一的时间
    const [, formattedRes] = useCountDown({
        // leftTime: now - Number(startTime),
        leftTime: timeLine[IPageStatus.statusA].end - getSystemTime(),
    });
    const { days, hours, minutes, seconds } = formattedRes;

    const handleCompletion = (val: number) => (val < 10 ? `0${val}` : val);

    return (
        <section className={styles.section} id="CES-2025-B">
            <EditorImg
                pc="https://websiteoss.ecoflow.com/upload/image/1733386597487/pc-ces-countdown-bg1.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1733386606898/m-ces-countdown-bg1.jpg"
                className="banner"
                alt={t('B_title')}
                aria-label={t('B_title')}
            ></EditorImg>
            <div className="countdown-box">
                <h5 className="title">{t('B_title')}</h5>
                <div className="countdown-content">
                    <div className="time">
                        <span className="num">{handleCompletion(days)}</span>
                        <span className="text">{t('B_days')}</span>
                    </div>
                    <span className="colon">:</span>
                    <div className="time">
                        <span className="num">{handleCompletion(hours)}</span>
                        <span className="text">{t('B_hours')}</span>
                    </div>
                    <span className="colon">:</span>
                    <div className="time">
                        <span className="num">{handleCompletion(minutes)}</span>
                        <span className="text">{t('B_minutes')}</span>
                    </div>
                    <span className="colon">:</span>
                    <div className="time">
                        <span className="num">{handleCompletion(seconds)}</span>
                        <span className="text">{t('B_seconds')}</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default B;
